import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import "./AddEmergencyStyle.css"
import { emMEmergencyDetail } from '../model/emEmergencyDetail';
import { emCar } from '../model/emCars';
import { emMember } from '../model/emMember';
import { emCarsEmergency } from '../model/emCarsEmergency';

type AddEmergencyProps = {
    emID: number;
    loggedState: number;
    loggedID:String;
  }

  const AddEmergency: React.FC<AddEmergencyProps> = ({ emID, loggedState, loggedID }) => {
    const options = ['Bitte auswählen', 'Brand', 'Hilfeleistung', 'Brandsicherheitsdienst' , 'Sonstiges'];
    const [selectedValueReason, setSelectedValueReason] = useState(0); 
    const [cars, setCars] = useState<emCar[]>([]);
    const [members, setMembers] = useState<emMember[]>([]);
    const [emergency, setEmergency] = useState<emMEmergencyDetail[]>([]);
    const [carsEmergency, setCarsEmergency] = useState<emCarsEmergency[]>([]);
    var extID: number;
    const {state} = useLocation();
    if(state != null){
        const {id} = state;
        extID = id;
    }
    else{
        extID=-2;
    }
    
    var emIDExt: number;
    const navigate = useNavigate();

    if(extID == -2){
        emIDExt = -1;
    }
    else{
        emIDExt = Number(extID);
    }

    if(emIDExt != null){
        emID = emIDExt;
    }
    useEffect(() => {
        const ReadCars = async (emID:number,loggedID:String) => {
            try {
              const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/ReadCarsOption.php', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  emID,
                  loggedID,
                }),
              });
        
              if (response.ok) {
                const data = await response.json();
                // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
                setCars(data);
              } else {
                const data = await response.json();
                console.error('Fehler beim lesen der Cars:', response.statusText);
              }
            } catch (error) {
              console.error('Fehler beim Request:', error);
            }
        };

        ReadCars(emID,loggedID);
      }, []);
      

      useEffect(() => {
        const ReadCars = async (emID:number) => {
            try {
              const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/ReadCars.php', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  emID,
                }),
              });
        
              if (response.ok) {
                const data = await response.json();
                // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
                setCarsEmergency(data);
              } else {
                const data = await response.json();
                console.error('Fehler beim lesen der Cars:', response.statusText);
              }
            } catch (error) {
              console.error('Fehler beim Request:', error);
            }
        };

        ReadCars(emID);
      }, []);

      useEffect(() => {
        const ReadMember = async (emID:number, loggedID:String) => {
          console.log(emID)
          console.log(loggedID)
            try {
              const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/ReadMember.php', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  emID,
                  loggedID,
                }),
              });
        
              if (response.ok) {
                const data = await response.json();
                console.log(data);
                setMembers(data);
              } else {
                const data = await response.json();
                console.error('Fehler beim lesen der Member:', response.statusText);
              }
            } catch (error) {
              console.error('Fehler beim Request:', error);
            }
        };

        ReadMember(emID,loggedID);
      }, []);

      useEffect(() => {
        const ReadEmergency = async (emID:number,loggedID:String) => {
            if(emID != -1){
                try {
                    const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/ReadEmergency.php', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json',
                      },
                      body: JSON.stringify({
                        emID,
                        loggedID,
                      }),
                    });
              
                    if (response.ok) {
                      const data = await response.json();
                      setEmergency(data);
                      var res:number = Number(data[0].reason) + 1;
                      setSelectedValueReason(res);
                    } else {
                      const data = await response.json();
                      console.error('Fehler beim lesen des Einsatz:', response.statusText);
                    }
                  } catch (error) {
                    console.error('Fehler beim Request:', error);
                  }   
            } 
        };
        ReadEmergency(emID,loggedID);
    }, []);

    const handleSelectChange = (index: number, e: React.ChangeEvent<HTMLSelectElement>) => {
        const updatedCarsEmergency = [...carsEmergency]; // Kopie des Arrays erstellen
        updatedCarsEmergency[index].carID = Number(e.target.value); // Aktualisiere die ID für das ausgewählte Auto
    
        setCarsEmergency(updatedCarsEmergency); // Aktualisiere den State mit der neuen Kopie des Arrays
      };
    
    const handleSelectChangeReason = (index: number, e: React.ChangeEvent<HTMLSelectElement>) => {
        const updatedEmergency = [...emergency]; // Kopie des Arrays erstellen
        updatedEmergency[index].reason = Number(e.target.value); // Aktualisiere die ID für das ausgewählte Auto
    
        setEmergency(updatedEmergency);
    };

    const handleInputChange = (index:number, propertyName:string, value:any) => {
        // Kopiere das aktuelle Array, um es nicht direkt zu ändern
        const updatedEmergency = [...emergency];
      
        // Aktualisiere die Eigenschaft des Objekts im Array
        updatedEmergency[index] = {
          ...updatedEmergency[index],
          [propertyName]: value,
        };
        setEmergency(updatedEmergency);
    }
    
    const handleInputChangeCars = (index:number, propertyName:string, value:any) => {
            // Kopiere das aktuelle Array, um es nicht direkt zu ändern
            const updatedEmergencyCars = [...carsEmergency];
          
            // Aktualisiere die Eigenschaft des Objekts im Array
            updatedEmergencyCars[index] = {
              ...updatedEmergencyCars[index],
              [propertyName]: value,
            };
      
        // Setze das aktualisierte Array als neuen Zustand
        setCarsEmergency(updatedEmergencyCars);
    };

    const handleInputChangeMember = (index:number, propertyName:string, value:any) => {
        // Kopiere das aktuelle Array, um es nicht direkt zu ändern
        const updatedEmergencyMember = [...members];
      
        

        // Aktualisiere die Eigenschaft des Objekts im Array
        updatedEmergencyMember[index] = {
          ...updatedEmergencyMember[index],
          [propertyName]: Number(value),
        };
  
    // Setze das aktualisierte Array als neuen Zustand
    setMembers(updatedEmergencyMember);
};

      const formatDate = (dateString:string) => {
        try{
            const dateObject = new Date(dateString);
            const formattedDate = dateObject.toISOString().split('T')[0];
            return formattedDate;
        }
        catch{
            return '';
        }
      };


      useEffect(() => {
        const InitEmergency = async (emID:number) => {
            if(emID===-1){
              const emergencyDetails: emMEmergencyDetail[] = [createEmptyEmergencyDetail()];
              setEmergency(emergencyDetails);
            }
        };

        InitEmergency(emID);
      }, []);

// Funktion, um ein leeres Detail zu erzeugen
const createEmptyEmergencyDetail = (): emMEmergencyDetail => {
  return {
    ID: 0,
    einsatzNr: 0,
    date: "",
    start: "",
    end: "",
    reason: 0,
    description: "",
    place: "",
    einsatzDesc: "",
    oil: "",
    soap: "",
    consum: "",
    damage: "",
    diffrents: ""
  };
};

const CreateUpdateEm = async (emID:number, emergency:emMEmergencyDetail, loggedID:String) => {
  try {
      const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/SetEmergency.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          //Einsatz => em_Einsätze
          emID,
          emergency,
          loggedID
        }),
      });

      if (response.ok) {
        const data = await response.json();
        // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
        if(data.status === 'success'){
          const lastID = data.lastID;
          CreateUpdateCars(emID,carsEmergency,loggedID,lastID);
          CreateUpdateMembers(emID,members,loggedID,lastID);
        }
        else{
          alert("Einsatz konnte nicht angelegt/aktualisiert werden");
        }
          
      } else {
        const data = await response.json();
        console.error('Fehler beim lesen des Einsatz:', response.statusText);
        alert("Einsatz konnte nicht aktualisiert werden");
      }
    } catch (error) {
      console.error('Fehler beim Request:', error);
    }   

};

const CreateUpdateCars = async (emID:number, carsEmergency:emCarsEmergency[], loggedID:String, lastID:String) => {
  console.log('Emergency cars' ,carsEmergency);
   try {
       const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/SetCars.php', {
         method: 'POST',
         headers: {
           'Content-Type': 'application/json',
         },
         body: JSON.stringify({
           //Einsatz => em_Einsätze
           emID,
           carsEmergency,
           loggedID,
           lastID
         }),
       });
 
       if (response.ok) {
         const data = await response.json();
         // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
         if(data.status === 'success'){
           
         }
         else{
           alert("Einsatz konnte nicht angelegt/aktualisiert werden");
         }
           
       } else {
         const data = await response.json();
         console.error('Fehler beim lesen des Einsatz:', response.statusText);
         alert("Einsatz konnte nicht aktualisiert werden");
       }
     } catch (error) {
       console.error('Fehler beim Request:', error);
     }   

};


const CreateUpdateMembers = async (emID:number, members:emMember[],loggedID:String,lastID:String) => {
  try {
      const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/SetMember.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          //Einsatz => em_Einsätze
          emID,
          members,
          loggedID,
          lastID
        }),
      });

      if (response.ok) {
        const data = await response.json();
        // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
        if(data.status === 'success'){
          
        }
        else{
          alert("Einsatz konnte nicht angelegt/aktualisiert werden");
        }
          
      } else {
        const data = await response.json();
        console.error('Fehler beim lesen des Einsatz:', response.statusText);
        alert("Einsatz konnte nicht aktualisiert werden");
      }
    } catch (error) {
      console.error('Fehler beim Request:', error);
    }   

};

    const CreateUpdateEmergency = () => {

        if(emergency.length === 0 || carsEmergency.length === 0 || members.length === 0){
              alert("Bitte Einsatzdaten,Fahrzeuge und Einsatzkräfte auswählen");
              return;
        }
   

        CreateUpdateEm(emID,emergency[0],loggedID);
    navigate("/MainPage");
    if(emID === -1){
        alert("Einsatz erfolgreich angelegt");               
    }
    else{
        alert("Einsatz erfolgreich aktualisiert");
    }
    };

    const HeaderHandle = (em:emMEmergencyDetail) => {
        if(emID == -1){
            return 'Neuer Einsatz';
        }
        else{
            return 'Bearbeitung von Einsatz ' + em.einsatzNr + ' ' + em.description;
        }
    };

    const handleGenerateText = async () => {
      try {
        const response = await fetch('https://api.openai.com/v1/chat/completions', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer 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`,  // API-Schlüssel hier korrekt einfügen
          },
          body: JSON.stringify({
            model: 'gpt-3.5-turbo',
            messages: [
              {
                role: 'system',
                content: 'Erstelle einen Text basierend auf den Stichworten mit passenden Hashtags.',
              },
              {
                role: 'user',
                content: `Korrigiere den folgenden Text. Füge kein Datum oder ortangaben hinzu: ${emergency[0].einsatzDesc}`,
              },
            ],
          }),
        });

        if (response.status === 429) {
          const content = `${emergency[0].einsatzDesc} zu viele Anfragen im Moment`;
          handleInputChange(0, 'einsatzDesc', content)
          return; // Stoppe die Ausführung
        }
    
        if (!response.ok) {
          const content = `${emergency[0].einsatzDesc} API Fehler: ${response.status} ${response.statusText}`;
          handleInputChange(0, 'einsatzDesc', content)
          return
        }

        
    
        const data = await response.json();
        console.log(data);
        const generatedContent = data.choices[0].message.content;
        handleInputChange(0, 'einsatzDesc', generatedContent)
      } catch (error) {
        console.error('Fehler beim Abrufen der API:', error);
      }
    };




  return (
    <div className='container' style={{ visibility: loggedState === 0 ? 'hidden' : 'visible' }}>
        <div className='emergency-container '>
        
            <div className="header">
                    <h2>{emergency && emergency[0] ? HeaderHandle(emergency[0]) : 'Neuer Einsatz'}</h2>
            </div>
            <div className="item-container">
                <label htmlFor="inputField" className="label">Einsatznummer:</label>
                <input type="text" id="inputField" className="input" value={emergency && emergency[0] ? emergency[0].einsatzNr : ''} onChange={(e) => handleInputChange(0, 'einsatzNr', e.target.value)}></input>
                <label htmlFor="inputField" className="label">Datum:</label>
                <input type="date" id="inputField" className="input" value={emergency && emergency[0] ? formatDate(emergency[0].date) : ''} onChange={(e) => handleInputChange(0, 'date', e.target.value)}></input> 
            </div>
            <div className="item-container">
                <label htmlFor="inputField" className="label">Einsatzbeginn:</label>
                <input type="time" id="inputField" className="input" value={emergency && emergency[0] ? emergency[0].start : ''} onChange={(e) => handleInputChange(0, 'start', e.target.value)}/>
                <label htmlFor="inputField" className="label">Einsatzende:</label>
                <input type="time" id="inputField" className="input" value={emergency && emergency[0] ? emergency[0].end : ''} onChange={(e) => handleInputChange(0, 'end', e.target.value)}/>
            </div>
            <div className="item-container">
                <label htmlFor="inputField" className="label">Einsatzstichwort:</label>
                <input type="text" id="inputField" className="input" value={emergency && emergency[0] ? emergency[0].description : ''} onChange={(e) => handleInputChange(0, 'description', e.target.value)}/>
                <label htmlFor="inputField" className="label">Einsatzort:</label>
                <input type="text" id="inputField" className="input" value={emergency && emergency[0] ? emergency[0].place : ''} onChange={(e) => handleInputChange(0, 'place', e.target.value)}/>
            </div>
            <div className="item-container">
                <label htmlFor="inputField" className="label">Einsatzanlass:</label>
                <select id="inputField" className="select" value={emergency && emergency[0] ? emergency[0].reason : 0}
                    onChange={(e) => handleSelectChangeReason(0, e)}>
                    {options.map((option, index) => (
                        <option key={index} value={index}>{option}</option>
                    ))}
                </select>
                <label htmlFor="inputField" className="label">Einsatzbeschreibung:</label>
                <div className="textarea-container">
                  <textarea className='textarea' value={emergency && emergency[0] ? emergency[0].einsatzDesc : ''} onChange={(e) => handleInputChange(0, 'einsatzDesc', e.target.value)}></textarea>
                  <button className="generate-button" onClick={handleGenerateText}>Text korrigieren</button>
                </div>
            </div>
        
            <ul>
                <li className="table-header">
                    <div className="col col-1">ID</div>
                    <div className="col col-2">Fahrzeug</div>
                    <div className="col col-3">Fahrzeugführer</div>
                    <div className="col col-4">Maschinist</div>
                </li>
                {carsEmergency.map((carsEM, index) => (
                    <li className="table-row" >
                        <div className="col col-1" data-label="ID">{ Number(index)+1}</div>
                        <div className="col col-2" data-label="Car">
                            <select className='select-table' value={Number(carsEM.carID)} onChange={(e) => handleSelectChange(index, e)}>
                                    {cars.map((option) => (
                                        <option key={option.ID} value={option.ID}>{option.name}</option>
                                    ))}
                            </select>
                        </div>
                        <div className="col col-3" data-label="CarDriver">
                            <input type="text" id="inputField" className="input-table" value={carsEM.driver} onChange={(e) => handleInputChangeCars(index, 'driver', e.target.value)}/>
                        </div>
                        <div className="col col-4" data-label="Machine">
                            <input type="text" id="inputField" className="input-table" value={carsEM.machinist} onChange={(e) => handleInputChangeCars(index, 'machinist', e.target.value)}/>
                        </div>
                    </li>
                ))}
            </ul>

            <div className="item-container">
                    <label htmlFor="inputField" className="label">Menge Ölbindemittel:</label>
                    <input type="text" id="inputField" className="input" value={emergency && emergency[0] ? emergency[0].oil : ''} onChange={(e) => handleInputChange(0, 'oil', e.target.value)}/>
                    <label htmlFor="inputField" className="label">Menge Schaummittel:</label>
                    <input type="text" id="inputField" className="input" value={emergency && emergency[0] ? emergency[0].soap : ''} onChange={(e) => handleInputChange(0, 'soap', e.target.value)}/>
            </div>
            <div className="item-container">
                    <label htmlFor="inputField" className="label">Sonstige Verbrauchsmaterialien:</label>
                    <textarea className='textarea' value={emergency && emergency[0] ? emergency[0].consum : ''} onChange={(e) => handleInputChange(0, 'consum', e.target.value)}></textarea>
                    <label htmlFor="inputField" className="label">Schäden:</label>
                    <textarea className='textarea' value={emergency && emergency[0] ? emergency[0].damage : ''} onChange={(e) => handleInputChange(0, 'damage', e.target.value)}></textarea>
            </div>

            <ul>
                <li className="table-header-member">
                    <div className="col col-1-member">ID</div>
                    <div className="col col-2-member">Name</div>
                    <div className="col col-3-member">Anwesend</div>
                    <div className="col col-4-member">Unter AGT</div>
                    <div className="col col-5-member">Einsatzbescheinigung</div>
                </li>
                {members.map((member, index) => (
                    <li className="table-row-member" key={member.ID}>
                        <div className="col col-1-member" data-label="ID">{member.ID}</div>
                        <div className="col col-2-member" data-label="name">{member.name}</div>
                        <div className="col col-3-member" data-label="Exist">
                            <input type="checkbox" id="inputField" className="input-table" checked={Number(member.active) === 1} onChange={(e) => handleInputChangeMember(index, 'active', e.target.checked)}/>
                        </div>
                        <div className="col col-4-member" data-label="AGT">
                            {Number(member.agt) === 1 && (
                                <input type="checkbox" id="inputField" className="input-table"  checked={Number(member.atg) === 1} onChange={(e) => handleInputChangeMember(index, 'atg', e.target.checked)}/>
                            )}
                        </div>
                        <div className="col col-5-member" data-label="Paper">
                            <input type="checkbox" id="inputField" className="input-table" checked={Number(member.paper) === 1} onChange={(e) => handleInputChangeMember(index, 'paper', e.target.checked)}/>
                        </div>
                    </li>
                ))}
            </ul>                         


            <div className="item-container">
                <label htmlFor="inputField" className="label">Notizen:</label>
                <textarea className='textarea' value={emergency && emergency[0] ? emergency[0].diffrents : ''} onChange={(e) => handleInputChange(0, 'diffrents', e.target.value)}></textarea>
            </div>
            {emID === -1 && (
            <button className='save-button' onClick={()=> CreateUpdateEmergency()}>Anlegen</button>
            )}
            {emID != -1 && (
            <button className='save-button' onClick={()=> CreateUpdateEmergency()}>Aktualisieren</button>
            )}
        </div>
      
    </div>
  )
}

export default AddEmergency
